import * as constant from './constant'
export const mutations = {
    [constant.ONBOARDING_USER_SETTING](state, payload) {
        if (payload) {
            payload.setting.assets = payload.setting.assets.filter(e => {
                if (['fund','gold', 'savings'].includes(e)) {
                    return e
                }
            })
            state.userConfiguration = payload
        }
    },
    [constant.ONBOARDING_GLOBAL_USER_SETTING](state, payload) {
        if (payload) {
            payload.setting.assets = payload.setting.assets.filter(e => {
                if (['fund','gold', 'savings'].includes(e)) {
                    return e
                }
            })
            state.globalConfiguration = payload
        }
    },
}